<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    :viewBox="viewBox" 
    :aria-labelledby="iconName"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"

  >
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="sfill">
      <path d="M0,16.55a4.2,4.2,0,0,1,0-.44c0-1.19,0-2.38,0-3.57,0-.35.12-.44.45-.44q5.9,0,11.8.06l4.71,0a1.81,1.81,0,0,0,.4,0c.72-.16.87-.54.42-1.12C16.4,9.22,15,7.41,13.6,5.64a4,4,0,0,0-2.29-1.47A3,3,0,0,0,7.88,5.86a2.83,2.83,0,0,0-.42,1.55,1.84,1.84,0,0,0,.83,1.47c.37.25.53.19.67-.25s.43-.76.88-.75A.77.77,0,0,1,10.51,9a1.42,1.42,0,0,1-1.6.87C7.35,9.73,6.7,8.51,6.58,7.16,6.39,5.2,7.45,4,9,3A4,4,0,0,1,11,2.4a3.57,3.57,0,0,1,1.86.49,11.3,11.3,0,0,1,3.11,2.9c.17.19.31.41.49.59.35.36.62.28.76-.19A10.4,10.4,0,0,1,18.83,2.7,6.77,6.77,0,0,1,22.43.25,6.44,6.44,0,0,1,27,.61,6.77,6.77,0,0,1,30.27,4,1.64,1.64,0,0,0,31.33,5l6,1.89c1.7.56,3.4,1.15,5.1,1.71.77.26,1.55.47,2.33.72l4.66,1.51,5.25,1.66L59.48,14c.28.09.59.27.51.59a.91.91,0,0,1-.52.53c-1.84.61-3.69,1.17-5.53,1.76l-6.87,2.21c-1.55.49-3.1.95-4.65,1.43L35,22.92c-1.28.4-2.54.84-3.83,1.16a2.14,2.14,0,0,0-1.51,1.25,8.93,8.93,0,0,1-3.92,4.07,5.33,5.33,0,0,1-5.24-.19,7.72,7.72,0,0,1-3.18-3.62c-.36-.77-.58-1.61-.87-2.42,0-.1-.07-.21-.12-.31-.21-.37-.49-.39-.81-.11a27.19,27.19,0,0,1-2.28,1.89,4.1,4.1,0,0,1-4.1.66,3.5,3.5,0,0,1-1.3-5.76,2,2,0,0,1,1.6-.82,1.22,1.22,0,0,1,1.07.86,1.31,1.31,0,0,1-.33,1.32.63.63,0,0,1-1-.22c-.52-.91-.95-.75-1.35.15a2.27,2.27,0,0,0,.36,2.24,3.43,3.43,0,0,0,1.43,1.18,2.13,2.13,0,0,0,2.49-.51c.64-.62,1.24-1.29,1.85-1.94l3-3.26c.32-.36.66-.71,1-1.07s.25-.56-.15-.71a1.48,1.48,0,0,0-.51-.09c-2,0-3.93,0-5.89,0-3,0-5.92-.07-8.88-.1C1.69,16.54.88,16.55,0,16.55Zm29.27,5.61a4.33,4.33,0,0,0,.78-.3c.44-.25.86-.56,1.3-.83l5.25-3.24c1-.64,2.06-1.25,3-2,.76-.55.74-1.05.15-1.62a2.43,2.43,0,0,0-.5-.41L30.25,8.05,30,7.89a1.21,1.21,0,0,0-1.61.26q-2.47,2.83-4.93,5.7a.83.83,0,0,0-.05,1.26l.15.2,3.06,4.07c.51.68,1,1.36,1.54,2A1.51,1.51,0,0,0,29.31,22.16ZM28.6,4.83a2.07,2.07,0,0,0,0-.26.9.9,0,0,0,0-.16A4.51,4.51,0,0,0,25.6,1.73a5.29,5.29,0,0,0-4.27.82,8.46,8.46,0,0,0-3.49,4.86,1,1,0,0,0,.17,1q1.57,1.9,3.18,3.78c.4.46.84.4,1.23-.08s.92-1.11,1.39-1.65l4.57-5.21A1.42,1.42,0,0,0,28.6,4.83ZM24.38,28a5,5,0,0,0,.84-.06A4.48,4.48,0,0,0,28,25.83a.92.92,0,0,0,0-1.27c-1.95-2.37-3.9-4.75-5.86-7.11-.39-.48-.74-.47-1.15,0-1,1.12-2,2.25-3,3.33a1.19,1.19,0,0,0-.27,1.34,10.07,10.07,0,0,0,2.13,3.68A6.17,6.17,0,0,0,24.38,28Z"></path>
    </g>
  </svg>
</template>
<script>
export default {
  data (){
    return {hover:false};
  },
  props: {
    viewBox: { type: String, default: '0 0 60 30'},
    iconName: { type: String, default: ''},
    width: { type: [Number, String], default: 36 },
    height: {type: [Number, String], default: 36 },
    iconColor: {type: String, default: 'currentColor'}
  },
  methods:{
    mouseenter: function(){
      this.hover = true;
    },
    mouseleave: function(){
      this.hover = false;
    }
  },
  computed:{
    sfill: function(){
      if (this.hover){
        return "#E34444";
      } else {
      return "#800000";
    }
    }
  }
}
</script>